// extracted by mini-css-extract-plugin
export default {"WageQualityPage":"WageQualityPage_WageQualityPage__Tz3CA","genderGrouping":"WageQualityPage_genderGrouping__NqDRn"};